module.exports = __webpack_public_path__ + "img/silver-sands-beach.8da43cea.png";